import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import { FormItem } from 'view-design'

// import 
// axios.defaults.baseURL = '/api';
//axios.defaults.baseURL = '/vtridaqinglei/web';泰康部署修改
//http request 拦截器
// 响应拦截
axios.interceptors.response.use(function (response) {
	// response.data.status = response.status || "";
	// if (!response.data.msg && response.data.code == 1) {
	//   response.data.msg = "服务端发生异常"
	// }
	return response.data
}, error => {
	// 判断状态

	if (error.response.status === 401) {
		var d = new Date();
		d.setDate(d.getDate() * 1 - 1);
		document.cookie = "userInfo" + "=" + encodeURIComponent(JSON.stringify("")) + ";expires=" + d.toGMTString();
		router.replace({
			name: 'Login',
		})
		location.reload();
		return error.response.data;
	}
	if (!error.response.data.msg) {
		error.response.data.msg = "";
	}
	// error.response.data.status = error.response.status || "";
	// return Promise.reject(error.response.data);
	return error.response.data;
})

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
/**
 * GET请求封装
 *
 * */
Vue.prototype.$get = function (url, data, fun, err, man_id = '') { //url接口 data 传入数据 fun 成功方法 err 错误方法
	var userInfo = getCookie("userInfo");
	axios({
		method: 'get',
		url: url,
		headers: {
			'Authentication': userInfo.token,
			id: man_id
		},
		params: data,
	}).then(function (res) {
		if (fun) {
			fun(res)
		}
	}).catch(function (error) {
		if (err) {
			console.log(error, 'errorerrorerrorerrorerror');
			err(error)
		}
	});
}
/**
 * POST请求封装
 *
 * */
Vue.prototype.$post = function (url, data, fun, err) {
	var userInfo = getCookie("userInfo");
	axios({
		method: 'post',
		url: url,
		headers: {
			'Authentication': userInfo.token,
		},
		data: data
	}).then(function (res) {
		if (fun) {
			fun(res)
		}
	}).catch(function (error) {
		if (err) {
			err(error)
		}
	});
}
/**
 * 修改请求封装
 *
 * */
Vue.prototype.$put = function (url, data, fun, err) {
	var userInfo = getCookie("userInfo");
	axios({
		method: 'put',
		url: url,
		headers: {
			// 'Authorization': userName ? userName.token_type + userName.access_token : "Basic emh4eTp6aHh5",
			'Authentication': userInfo.token,
			"Content-Type": "application/json;charset=UTF-8"
		},
		data: data
	}).then(function (res) {
		if (fun) {
			fun(res)
		}
	})
		.catch(function (error) {
			if (err) {
				err(error)
			}
		});
}
/**
 * 删除请求封装
 * 
 * */
Vue.prototype.$delete = function (url, data, fun, err, isbody) {
	var userInfo = getCookie("userInfo");
	axios({
		method: 'delete',
		url: url,
		headers: {
			'Authentication': userInfo.token
		},
		data: data
	}).then(function (res) {
		if (fun) {
			fun(res)
		}
	})
		.catch(function (error) {
			if (err) {
				err(error)
			}
		});
}

/**
 * POST请求封装
 *
 * */
Vue.prototype.$loginpost = function (url, data, fun, err) {
	axios({
		method: 'post',
		url: url,
		data: data
	}).then(function (res) {
		if (fun) {
			fun(res)
		}
	}).catch(function (error) {
		if (err) {
			err(error)
		}
	});
}

function getCookie(c_name) {
	var name = c_name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = decodeURIComponent(ca[i].trim()); // 解码
		if (c.indexOf(name) == 0) {
			// console.log(JSON.parse(c.substring(name.length, c.length)))
			return JSON.parse(c.substring(name.length, c.length));
		}
	}
	return "";
}


/**
 * 导出
 *
 * */
Vue.prototype.$getExport = function (url, data, fun, err) {
	var userInfo = getCookie("userInfo");
	axios({
		method: 'get',
		url: url,
		responseType: "blob",
		headers: {
			'Authentication': userInfo.token,
			'Content-Type': 'application/octet-stream'
		},
		params: data
	}).then(function (res) {
		if (fun) {
			fun(res)
		}
	}).catch(function (error) {
		if (err) {
			err(error)
		}
	});
}